import { useState } from "react";
import { toast } from "sonner";
import { MailWarning } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const VerifyEmailBanner = () => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success(`Enviamos um novo link para ${user.email}.`);
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm text-amber-100" data-testid="verify-email-banner">
      <MailWarning className="h-5 w-5 shrink-0 text-amber-300" />
      <span className="min-w-0 flex-1">Confirme seu e-mail <b>{user.email}</b> pelo link que enviamos. Isso protege sua conta e permite recuperar a senha.</span>
      <Button size="sm" variant="outline" disabled={busy} onClick={resend} className="rounded-full border-amber-400/60 bg-transparent text-amber-100" data-testid="verify-email-resend">Reenviar link</Button>
    </div>
  );
};
